import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import LogoCarousel from '@segment/templates/LogoCarousel'
import NavigationV2 from '@segment/templates/Navigation2'

import LayoutBase from '@segment/next-shared/layout'

import Whenever from './components/Whenever'
import EnsureDataPrivacy from './components/EnsureDataPrivacy'
import LearnMore from './components/LearnMore'
import GettingStarted from './components/GettingStarted'
import TestimonialsSlider from './components/TestimonialsSlider'
import Hero from './components/Hero'

const ActivateCustomerDataView = () => {
  return (
    <AppearanceProvider appearance="twilioLight">
      <LayoutBase
        pageTitle="Activate Customer Data | Twilio Segment"
        pageDescription="Explore how Twilio Segment's extensible customer data platform can help you quickly and easily create and activate unified customer profiles across every tool you use."
      >
        <NavigationV2 />
        <AppearanceProvider appearance="twilioDark">
          <Hero />
        </AppearanceProvider>
        <Main>
          <LogoCarouselWrapper>
            <LogoCarousel />
          </LogoCarouselWrapper>
          <Whenever />
          <EnsureDataPrivacy />
          <LearnMore />
          <TestimonialsSlider />
          <GettingStarted />
        </Main>
        <Footer />
      </LayoutBase>
    </AppearanceProvider>
  )
}

const Main = styled.main``

const LogoCarouselWrapper = styled.div`
  padding: 80px 0;
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    padding: 40px 0;
  }
`

export default ActivateCustomerDataView
